import SetPassword from "../Components/SetPassword";
import Title from "../Common/Title";
import { Flex } from "@chakra-ui/react";
import { useState } from "react";
import { useResetPasswordProxy } from "../Custom Hooks/useResetPasswordProxy";

export default function ResetPassword() {
  const [newPassword, setNewPassword] = useState("");
  const [reenterPassword, setReenterPassword] = useState("");
  const { continueAction, cancelAction, pageLevelError } =
    useResetPasswordProxy({ newPassword, reenterPassword });

  return (
    <Flex direction="column"  maxW={544} padding={38} mx="auto">
      <Title text="Reset your password" />
      <SetPassword
        description={"To protect your account and information, please reset your password. You can use your existing MYSGI password if it meets the new criteria."}
        password={newPassword}
        setPassword={setNewPassword}
        retypePassword={reenterPassword}
        setRetypePassword={setReenterPassword}
        onContinue={continueAction.act}
        onCancel={cancelAction.act}
        disableContinue={false}
        pageLevelError={pageLevelError}
        continueButtonName="Continue"
      />
    </Flex>
  );
}
